import type { ReactNode } from 'react';
import {
  ArticleIconMenu,
  Calendar,
  Clients,
  EventsIconMenu,
  SpecialistsIconMenu,
  StoreMenu,
  VideoIconMenu,
} from '@shared/assets/index.ts';

export const iconsMap = {
  shop: <StoreMenu />,
  clients: <Clients />,
  programs: <VideoIconMenu />,
  consultations: <EventsIconMenu />,
  schedule: <EventsIconMenu />,
  events: <Calendar />,
  coaches: <SpecialistsIconMenu />,
  articles: <ArticleIconMenu />,
} as { [key: string]: ReactNode };
